import { type FC, type HTMLProps } from "react";

export interface ButtonProps extends Omit<HTMLProps<HTMLButtonElement>, "ref" | "className"> {
    classes?: Array<string>;
    focus?: boolean;
    disabled?: boolean;
    type?: "button" | "submit" | "reset";
}

export const DISABLED_BUTTON_CLASSES = "disabled:outline-hidden disabled:text-gray-500 disabled:bg-gray-300 " +
    "hover:disabled:text-gray-500 hover:disabled:bg-gray-300 disabled:cursor-not-allowed";

export const DEFAULT_BUTTON_CLASSES = "cursor-pointer border-none rounded-lg select-none p-4 text-[1em] " +
    "font-bold tracking-wider whitespace-nowrap bg-primary hover:bg-primary-dark text-white";

const Button: FC<ButtonProps> = ({
    classes,
    disabled,
    type,
    children,
    ...otherProps
}) => {
    const classArray = [ DEFAULT_BUTTON_CLASSES, DISABLED_BUTTON_CLASSES ];

    if(Array.isArray(classes)) {
        classArray.push(...classes);
    }

    return (
        <button
            {...otherProps}
            type={type || "button"}
            disabled={disabled}
            className={classArray.join(" ")}
        >
            {children}
        </button>
    );
};

export default Button;
